import * as React from 'react';
import { BaSeHeading1, BaSeHeading3, BaSeTheme } from '@base/react';
import { TitleContent } from './title-styled';

export const Title = ({
  titulo,
  subtitulo,
  paddingContent,
  paddingSubtitulo,
}) => {
  const { azulSebrae30 } = BaSeTheme.colors.institucionais;
  return (
    <TitleContent paddingContent={paddingContent}>
      <BaSeHeading1 color={azulSebrae30}>{titulo}</BaSeHeading1>
      <BaSeHeading3
        color={azulSebrae30}
        style={{ paddingTop: `${paddingSubtitulo}` }}
      >
        {subtitulo}
      </BaSeHeading3>
    </TitleContent>
  );
};
